import { action, computed, makeObservable, observable } from 'mobx';
import FeatureFlag from '../models/featureFlag';
import processIncomingData from '../processIncomingData';
import * as utils from '../../helpers/utils';

class FeatureFlagStore {
  constructor(rootStore) {
    makeObservable(this);
    this.rootStore = rootStore;
  }

  @observable featureFlags = [];

  @computed get getEnabledFeatureFlags() {
    const { loggedUserId } = this.rootStore.commonStore;

    const [currentUser] = this.rootStore.contactStore.contacts.filter(
      (contact) => contact._id === loggedUserId
    );

    return this.featureFlags
      .filter(
        (feature) =>
          feature.IsEnabled &&
          (currentUser?.ContactType?.TypeId === utils.ContactTypeEnum.Support.TypeId ||
            !feature.ForSupportContactsOnly)
      )
      .map((feature) => feature.FeatureName);
  }

  @action UpsertAndGet(incObj) {
    return processIncomingData(incObj, this.rootStore, this.featureFlags, FeatureFlag);
  }
}

export default FeatureFlagStore;
